import React from 'react';
import { useParams } from 'react-router-dom';

const EventDetail = () => {
  const { evtSrno } = useParams();

  const getContents = () => {
    if (evtSrno === '1') {
      return (
        <div className="event_wrap">
          <div>
            <img src="/assets/images/evt/event_1_0.png" className="Width-100" />
          </div>
          <div>
            <img src="/assets/images/evt/event_1_1.png" className="Width-100" />
          </div>

          <div className="fs-13 font-666 pl-20 pr-20 lh-20 pb-100 ">
            상품권 교환은 Staff에 말씀 해 주세요.
            <br />
            사업단의 사정에 따라 상품은 변경되거나 중단될 수 있습니다.
            <br />
            아래 이벤트 보러가기 페이지에서 참여 할수 있습니다.
            <p className="fs-12 font-999 mt-10">해당 이벤트는 Google Play Store / App Store 와 무관한 이벤트임을 안내드립니다.</p>
          </div>
        </div>
      );
    }

    return <></>;
  };

  return <>{getContents()}</>;
};

export default EventDetail;
